import styled from 'styled-components';
import { StyledIcon as Icon } from '../../Icons';
export const Button = styled.a `
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
`;
export const Title = styled.p `
    color: rgb(255, 255, 255);
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -0.12px;
    margin: 0;

    &:hover {
        text-decoration: underline;
        text-decoration-color: white;
    }
`;
export const StyledIcon = styled(Icon) `
    width: 16px;
    height: 16px;
    margin-right: 6px;
`;
//# sourceMappingURL=index.js.map